export class NotValidError extends Error {}
